<template>
  <div class="wrapper">
    <textarea
      :id="id"
      ref="textarea"
      v-model="input"
      class="comment-textarea"
      rows="1"
      :disabled="!isEditing"
      maxlength="140"
    />

    <div class="wrapper__actions">
      <BaseButtonIcon
        v-if="!isEditing"
        outline
        size="tiny"
        @click="handleStartEditing"
        ><PencilIcon
      /></BaseButtonIcon>

      <BaseButtonIcon
        v-if="isEditing"
        theme="blue"
        outline
        size="tiny"
        @click="
          () => {
            emit('onSubmit', unref(input))
            isEditing = false
          }
        "
        ><CheckmarkIcon class="actions__approve-icon"
      /></BaseButtonIcon>
    </div>
  </div>
</template>
<script setup lang="ts">
import CheckmarkIcon from '@/components/icon_components/CheckmarkIcon.vue'
import BaseButtonIcon from '@/components/generics/base/BaseButtonIcon.vue'
import { nextTick, ref, unref } from 'vue'
import PencilIcon from '@/components/icon_components/PencilIcon.vue'
import { useTextareaAutosize } from '@vueuse/core'

const props = withDefaults(
  defineProps<{
    id: string
    value?: string
    placeholder?: string | undefined
  }>(),
  {
    id: '',
    value: '',
    placeholder: '-',
  }
)

const emit = defineEmits<{
  (e: 'onSubmit', text: string): void
}>()
const isEditing = ref(false)
const { textarea, input } = useTextareaAutosize({
  input: props.value,
})

const handleStartEditing = async () => {
  isEditing.value = true
  await nextTick()
  textarea.value.focus()
}
</script>

<style lang="scss" scoped>
.remark-readonly {
  white-space: pre-wrap;
}

.wrapper {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 4px;

  &__actions {
    display: flex;
    gap: $spacing-4xs;
  }
}

.actions {
  &__cancel-icon {
    color: $color-blue-45;
  }
}

.comment-textarea {
  box-sizing: border-box;
  border-radius: $border-radius-s;
  border: 1px solid $border-color-default;
  overflow: hidden;
  resize: none; /* Prevents user resizing */
  width: 100%;
  min-height: 38px;
  padding: 8px;
}
</style>
